import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-success",
  templateUrl: "./med-icon-success.component.html",
})
export class MedIconSuccessComponent extends SvgMixinComponent {}
